module.exports = __webpack_public_path__ + "img/mail.164553d5.svg";